import { todayYMD } from "../lib/db";

function addDays(ymd: string, days: number): string {
  const [y, m, d] = ymd.split("-").map(Number);
  const dt = new Date(y!, m! - 1, d! + days);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
}

function pretty(ymd: string): string {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y!, m! - 1, d!).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}

/**
 * Due-date pill: red when overdue, amber when due within 3 days, muted
 * otherwise. The native date input sits invisibly on top for editing.
 */
export default function DueDatePill({
  dueOn,
  completed,
  onChange,
}: {
  dueOn: string | null;
  completed: boolean;
  onChange: (dueOn: string | null) => void;
}) {
  const today = todayYMD();
  const overdue = !!dueOn && !completed && dueOn < today;
  const soon = !!dueOn && !completed && !overdue && dueOn <= addDays(today, 3);

  const cls = overdue
    ? "bg-flag-bg text-flag"
    : soon
      ? "bg-[#fdf0dc] text-[#9a5b00]"
      : dueOn
        ? "bg-neutral-bg text-ink-soft"
        : "border border-dashed border-line-strong text-faint";

  return (
    <div className="relative inline-flex items-center">
      <input
        type="date"
        value={dueOn ?? ""}
        onChange={(e) => onChange(e.target.value || null)}
        className="absolute inset-0 cursor-pointer opacity-0"
        aria-label="Due date"
      />
      <span
        className={`pointer-events-none whitespace-nowrap rounded-full px-2 py-0.5 font-mono text-[10px] font-medium tabular-nums ${cls}`}
      >
        {dueOn ? pretty(dueOn) : "due"}
      </span>
    </div>
  );
}
